import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import './Infrastructure.css'

function InfrastructureDashboard() {
  return (
    <div className="infrastructure-dashboard">
      {/* Inactive State */}
      <div className="inactive-state">
        <div className="inactive-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="2" y="2" width="20" height="8" rx="2"/>
            <rect x="2" y="14" width="20" height="8" rx="2"/>
            <line x1="6" y1="6" x2="6.01" y2="6"/>
            <line x1="6" y1="18" x2="6.01" y2="18"/>
          </svg>
        </div>
        <h2 className="inactive-title">Infrastructure is not active</h2>
        <p className="inactive-description">
          Deploy applications, manage domains, and scale your infrastructure with Namelyft.
        </p>
        
        <div className="features-grid">
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="16 18 22 12 16 6"/>
              <polyline points="8 6 2 12 8 18"/>
            </svg>
            <div>
              <span className="feature-title">Deploy from Git</span>
              <span className="feature-desc">Connect your repository and deploy automatically</span>
            </div>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="2" y1="12" x2="22" y2="12"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
            <div>
              <span className="feature-title">Custom Domains</span>
              <span className="feature-desc">Register and manage domains with free SSL</span>
            </div>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 20V10"/>
              <path d="M12 20V4"/>
              <path d="M6 20v-6"/>
            </svg>
            <div>
              <span className="feature-title">Auto-Scaling</span>
              <span className="feature-desc">Scale resources automatically with demand</span>
            </div>
          </div>
          <div className="feature-item">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            <div>
              <span className="feature-title">DDoS Protection</span>
              <span className="feature-desc">Enterprise-grade security included</span>
            </div>
          </div>
        </div>

        <div className="pricing-info">
          <div className="pricing-header">
            <span className="pricing-label">Pricing</span>
            <span className="pricing-badge">Usage-based</span>
          </div>
          <div className="pricing-details">
            <div className="pricing-item">
              <span>Base</span>
              <span>Free tier available</span>
            </div>
            <div className="pricing-item">
              <span>Compute</span>
              <span>Pay per hour</span>
            </div>
            <div className="pricing-item">
              <span>Bandwidth</span>
              <span>First 100GB free</span>
            </div>
          </div>
        </div>

        <button className="btn btn-primary btn-large">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M5 12h14"/>
            <path d="M12 5v14"/>
          </svg>
          Activate Namelyft
        </button>

        <p className="activate-note">
          This will be added to your monthly Hubthrill bill. You can deactivate at any time.
        </p>
      </div>
    </div>
  )
}

function Infrastructure() {
  const location = useLocation()
  const isOverview = location.pathname === '/dashboard/infrastructure'

  const subRoutes = [
    { name: 'Overview', path: '/dashboard/infrastructure', end: true },
    { name: 'Projects', path: '/dashboard/infrastructure/projects' },
    { name: 'Domains', path: '/dashboard/infrastructure/domains' },
    { name: 'Deployments', path: '/dashboard/infrastructure/deployments' },
    { name: 'Usage', path: '/dashboard/infrastructure/usage' }
  ]

  return (
    <div className="infrastructure-page">
      {/* Header */}
      <div className="page-header">
        <div className="header-info">
          <div className="module-badge infrastructure inactive">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="20" height="8" rx="2"/>
              <rect x="2" y="14" width="20" height="8" rx="2"/>
              <line x1="6" y1="6" x2="6.01" y2="6"/>
              <line x1="6" y1="18" x2="6.01" y2="18"/>
            </svg>
          </div>
          <div>
            <h1 className="page-title">Infrastructure</h1>
            <p className="page-subtitle">Namelyft · Cloud hosting and deployment platform</p>
          </div>
        </div>
        <div className="header-badge inactive">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
          </svg>
          Module not active
        </div>
      </div>

      {/* Sub Navigation (disabled) */}
      <nav className="sub-nav disabled">
        {subRoutes.map(route => (
          <span key={route.path} className="sub-nav-link disabled">
            {route.name}
          </span>
        ))}
      </nav>

      {/* Content */}
      {isOverview ? <InfrastructureDashboard /> : <Outlet />}
    </div>
  )
}

export default Infrastructure
